import React from 'react';
import { Link } from 'react-router';

const BucketHeader = (props) => {
    const size = (props.showSize) ? ` (${props.size})` : '';
    const text = `${props.name}${size}`;
    return (
        <header className="collection_header">
            <div className="collection_title">
                <Link to={props.link} className="collection_title_link" data-route="false">
                    {text}
                </Link>
            </div>
        </header>
    );
};

BucketHeader.propTypes = {
    name: React.PropTypes.string,
    size: React.PropTypes.number,
    link: React.PropTypes.string,
    showSize: React.PropTypes.bool
};

BucketHeader.defaultProps = {
    showSize: true
};

export default BucketHeader;



// WEBPACK FOOTER //
// ./app/page/buckets/BucketHeader.js